import axiosRagflow from 'constants/axios';
import * as Document from 'containers/desktop/KnowledgeBases/types/Document';
import * as DocumentList from 'containers/desktop/KnowledgeBases/types/DocumentList';

export * as KnowledgeBase from 'containers/desktop/KnowledgeBases/types/KnowledgeBase';

export type Type = {
	id: string;
	name: string;
	documents: DocumentList.Type;
};

export function create(): Type {
	return {
		id: '',
		name: '',
		documents: DocumentList.create(),
	};
}

export async function uploadDocument(obj: Type, document: FormData): Promise<Type> {
	await axiosRagflow.post(`/api/v1/datasets/${obj.id}/documents`, document, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
	return {
		id: obj.id,
		name: obj.name,
		documents: await DocumentList.getAllFromApi(obj.id),
	};
}

export async function deleteDocument(obj: Type, document: Document.Type): Promise<Type> {
	await Document.deleteFromApi(document, obj.id);
	return {
		id: obj.id,
		name: obj.name,
		documents: obj.documents.filter((d) => d.id !== document.id),
	};
}

export async function parseDocument(obj: Type, document: Document.Type): Promise<Type> {
	return {
		id: obj.id,
		name: obj.name,
		documents: await DocumentList.parseFromApi(obj.documents, document.id, obj.id),
	};
}

export async function stopParsingDocument(obj: Type, document: Document.Type): Promise<Type> {
	return {
		id: obj.id,
		name: obj.name,
		documents: await DocumentList.stopParsingFromApi(obj.documents, document.id, obj.id),
	};
}
